import {Action} from '@ngrx/store';
import {FunkprotokollFall, FunkprotokollEintrag, Veranstaltung} from '../../../clients/veranstaltungen';

export const PAGE_STATE_RESET = '[FunkprotokollierungPage] Page State reset';

export const AUSWAHL_AUFHEBEN = '[FunkprotokollierungPage] Auswahl aufheben';

export const VERANSTALTUNGEN_AUSGEWAEHLT = '[FunkprotokollierungPage] Veranstaltung ausgewählt';

export const PROTOKOLL_FALL_AUSGEWAEHLT = '[FunkprotokollierungPage] Protokoll Fall ausgewählt';

export const NEUER_PROTOKOLL_FALL = '[FunkprotokollierungPage] Neuer Protokoll Fall';

export const PROTOKOLL_FALL_ENTFERNEN = '[FunkprotokollierungPage] Protokoll Fall entfernen';

export const PROTOKOLL_FALL_SPEICHERN = '[FunkprotokollierungPage] Protokoll Fall speichern';

export const PROTOKOLL_FALL_EINGABE = '[FunkprotokollierungPage] Protokoll Fall Eingabe';

export const PROTOKOLL_FALL_ABSCHLIESSENEN = '[FunkprotokollierungPage] Protokoll Fall abschließen';

export const PROTOKOLL_FALL_REAKTIVIEREN = '[FunkprotokollierungPage] Protokoll Fall reaktivieren';

export const PROTOKOLL_FALL_EINGABE_TITEL_MELDUNG = '[FunkprotokollierungPage] Protokoll Fall Eingabe Titel und Meldung';

export const PROTOKOLL_EINTRAG_AUSGEWAEHLT = '[FunkprotokollierungPage] Protokolleintrag ausgewählt';

export const NEUER_PROTOKOLL_EINTRAG = '[FunkprotokollierungPage] Neuer Protokolleintrag';

export const PROTOKOLL_EINTRAG_ENTFERNEN = '[FunkprotokollierungPage] Protokolleintrag entfernen';

export const PROTOKOLL_EINTRAG_SPEICHERN = '[FunkprotokollierungPage] Protokolleintrag speichern';

export const PROTOKOLL_EINTRAG_EINGABE = '[FunkprotokollierungPage] Protokolleintrag Eingabe';

export const PROTOKOLL_FALL_UND_EINTRAG_SPEICHERN = '[FunkprotokollierungPage] Protokoll Fall und Eintrag speichern';

export const INCIDENT_ERSTELLEN = '[FunkprotokollierungPage] Incident erstellen';

// PAGE STATE RESET
export class PageStateResetAction implements Action {
    readonly type = PAGE_STATE_RESET;
}

// Seitenactions
export class AuswahlAufheben implements Action {
    readonly type = AUSWAHL_AUFHEBEN;

    constructor() {}
}

export class VeranstaltungAusgewaehlt implements Action {
    readonly type = VERANSTALTUNGEN_AUSGEWAEHLT;

    constructor(public payload: Veranstaltung) {}
}

export class ProtokollFallAusgewaehlt implements Action {
    readonly type = PROTOKOLL_FALL_AUSGEWAEHLT;

    constructor(public payload: FunkprotokollFall) {}
}

export class NeuerProtokollFall implements Action {
    readonly type = NEUER_PROTOKOLL_FALL;

    constructor() {}
}

export class ProtokollFallEntfernen implements Action {
    readonly type = PROTOKOLL_FALL_ENTFERNEN;

    constructor() {}
}

export class ProtokollFallSpeichern implements Action {
    readonly type = PROTOKOLL_FALL_SPEICHERN;

    constructor(public neu: boolean) {}
}

export class ProtokollFallEingabe implements Action {
    readonly type = PROTOKOLL_FALL_EINGABE;

    constructor(public payload: FunkprotokollFall) {}
}

export class ProtokollFallAbschliessen implements Action {
    readonly type = PROTOKOLL_FALL_ABSCHLIESSENEN;

    constructor() {}
}

export class ProtokollFallReaktivieren implements Action {
    readonly type = PROTOKOLL_FALL_REAKTIVIEREN;

    constructor() {}
}

export class ProtokollFallEingabeTitelMeldung implements Action {
    readonly type = PROTOKOLL_FALL_EINGABE_TITEL_MELDUNG;

    constructor(public payload: {
        titel: string,
        meldung: string
    }) {}
}

export class ProtokollEintragAusgewaehlt implements Action {
    readonly type = PROTOKOLL_EINTRAG_AUSGEWAEHLT;

    constructor(public payload: FunkprotokollEintrag) {}
}

export class NeuerProtokollEintrag implements Action {
    readonly type = NEUER_PROTOKOLL_EINTRAG;

    constructor() {}
}

export class ProtokollEintragEntfernen implements Action {
    readonly type = PROTOKOLL_EINTRAG_ENTFERNEN;

    constructor() {}
}

export class ProtokollEintragSpeichern implements Action {
    readonly type = PROTOKOLL_EINTRAG_SPEICHERN;

    constructor(public neu: boolean) {}
}

export class ProtokollEintragEingabe implements Action {
    readonly type = PROTOKOLL_EINTRAG_EINGABE;

    constructor(public payload: FunkprotokollEintrag) {}
}

export class ProtokollFallUndEintragSpeichern implements Action {
    readonly type = PROTOKOLL_FALL_UND_EINTRAG_SPEICHERN;

    constructor(public neuerFall: boolean, public neuerEintrag: boolean) {}
}

export class IncidentErstellenUiAction implements Action {
    readonly type = INCIDENT_ERSTELLEN;

    constructor() {}
}


export type Actions =
    | PageStateResetAction
    | VeranstaltungAusgewaehlt
    | ProtokollFallAusgewaehlt
    | NeuerProtokollFall
    | ProtokollFallEntfernen
    | ProtokollFallSpeichern
    | ProtokollFallEingabe
    | ProtokollFallAbschliessen
    | ProtokollFallReaktivieren
    | ProtokollFallEingabeTitelMeldung
    | ProtokollEintragAusgewaehlt
    | NeuerProtokollEintrag
    | ProtokollEintragEntfernen
    | ProtokollEintragSpeichern
    | ProtokollEintragEingabe
    | ProtokollFallUndEintragSpeichern
    | IncidentErstellenUiAction
    ;
